/*
 * "Legg til en gave" one-tap add-ons in the cart. Markup: snippets/kardima-cart-addons.liquid.
 * Spec: docs/pdp-spec.md "Cart add-ons (Legg til en gave)".
 *
 * One delegated click handler on the document, because the drawer's contents are replaced after
 * every cart change. Lines are added WITHOUT properties: assets/kardima-gift.js only touches lines
 * tagged _kardima_gift, so its reconciler leaves these alone.
 *
 * Drawer: add with the drawer sections in the same request and let Dawn's renderContents() swap
 * them in (the same path as the product form). Cart page: reload once the line is in, so the
 * items, totals and the add-on list all come from the server.
 */
(function () {
  'use strict';
  if (window.kardimaCartAddons) return;
  window.kardimaCartAddons = true;

  var SOURCE = 'kardima-cart-addons';

  function cartUpdateEvent() {
    return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-kardima-addon]') : null;
    if (!button || button.disabled) return;
    event.preventDefault();

    var root = button.closest('[data-kardima-addons]');
    var error = root ? root.querySelector('.kardima-addons__error') : null;
    var drawer = button.closest('cart-drawer');
    var label = button.textContent;
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    var body = { items: [{ id: Number(button.dataset.kardimaAddon), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Legger til';
    if (error) error.hidden = true;

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || data.message || response.status);
          return data;
        });
      })
      .then(function (data) {
        if (!drawer) {
          window.location.reload();
          return;
        }
        if (data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
        if (typeof window.publish === 'function') {
          window.publish(cartUpdateEvent(), { source: SOURCE, productVariantId: body.items[0].id });
        }
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('[kardima-cart-addons]', err);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        if (error) error.hidden = false;
      });
  });
})();
